__turbopack_context__.v({
  "baseForm": "BaseForm-module-scss-module__QedE5q__baseForm",
});
